import React, { useEffect, useState } from 'react'
import { getAllTickers } from "../../services/TickerService";
import { isLargeScreen } from "../../utilities/ScreenView";
import Shark from './Shark';

const Trange  = () => {
    const trangenames = [
          { label: "audcad : trg", value: "AUDCAD", }        // 0
        , { label: "audusd : trg", value: "AUDUSD", }        // 1
        , { label: "btcusd : trg", value: "BTCUSD", }        // 2        
        , { label: "deuidx : trg", value: "DEUIDXEUR" }      // 3
        , { label: "euraud : trg", value: "EURAUD", }        // 4
        , { label: "eurgbp : trg", value: "EURGBP", }        // 5        
        , { label: "eurusd : trg", value: "EURUSD", }        // 6
        , { label: "gbpchf : trg", value: "GBPCHF", }        // 7
        , { label: "gbpusd : trg", value: "GBPUSD", }        // 8
        , { label: "hk40   : trg", value: "HKGIDXHKD" }      // 9        
        , { label: "nzdusd : trg", value: "NZDUSD", }        // 10 
        , { label: "us30   : trg", value: "USA30IDXUSD", }   // 11
        , { label: "nas100 : trg", value: "USATECHIDXUSD", } // 12
        , { label: "usdcad : trg", value: "USDCAD", }        // 13
        , { label: "usdjpy : trg", value: "USDJPY", }        // 14      
        , { label: "xagusd : trg", value: "XAGUSD", }        // 15
        , { label: "xauusd : trg", value: "XAUUSD", }        // 16        
    ];

    const trangenamesshort = [
          { label: "audcad", value: "AUDCAD", }        // 0
        , { label: "audusd", value: "AUDUSD", }        // 1
        , { label: "btcusd", value: "BTCUSD", }        // 2          
        , { label: "deuidx", value: "DEUIDXEUR" }      // 3
        , { label: "euraud", value: "EURAUD", }        // 4
        , { label: "eurgbp", value: "EURGBP", }        // 5
        , { label: "eurusd", value: "EURUSD", }        // 6
        , { label: "gbpchf", value: "GBPCHF", }        // 7
        , { label: "gbpusd", value: "GBPUSD", }        // 8
        , { label: "hk40  ", value: "HKGIDXHKD" }      // 9        
        , { label: "nzdusd", value: "NZDUSD", }        // 10                
        , { label: "us30  ", value: "USA30IDXUSD", }   // 11
        , { label: "nas100", value: "USATECHIDXUSD", } // 12
        , { label: "usdcad", value: "USDCAD", }        // 13
        , { label: "usdjpy", value: "USDJPY", }        // 14     
        , { label: "xagusd", value: "XAGUSD", }        // 15
        , { label: "xauusd", value: "XAUUSD", }        // 16
    ];        

    const [tickers, setTickers] = useState([])
    const [tickerssaved, setTickerssaved] = useState([])
    
    useEffect(() => {
            // const interval = setInterval(() => { listMarketplace(); listAllTickers(); setDate(new Date()); }, 10000)
            const interval = setInterval(() => { listAllTickers(); }, 2000)
            return () => {  clearInterval(interval); }
        });

    function listAllTickers() {
        getAllTickers().then((response) => {
            setTickerssaved(response.data);
        }).catch(error => { console.log(error); })
        if (tickerssaved.length === 17) { setTickers(tickerssaved); }
    }
        
    function getTrangeName(idx) {
        return trangenames[idx].label;
    }

    function getTrangeNameShort(idx) {
        return trangenamesshort[idx].label;
    }

    function showTrangePercent(idx) {

        var percent = 0;

        if (tickers[idx] !== undefined && tickers[idx].instrument === trangenames[idx].value)
        {   if (tickers[idx].trange === 0.00 && tickers[idx].maxTrange === 0.0) return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary">&nbsp;&nbsp;0.00%</td>
            percent = ((tickers[idx].trange / tickers[idx].maxTrange) * 100).toFixed(2);  }
        
        if (percent === 0.0) return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary">&nbsp;&nbsp;0.00%</td>
        if (percent === '0.00') return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary">&nbsp;&nbsp;{percent}%</td>

        if (percent > 0 && percent < 10) return <td style={{ fontSize: 'small' }} className="col col-lg-1">&nbsp;&nbsp;{percent}%</td>
        if (percent > 9.99 && percent < 20) return <td style={{ fontSize: 'small', backgroundColor: '#fffff0' }} className="col col-lg-1">{percent}%</td>
        if (percent > 19.99 && percent < 50) return <td style={{ fontSize: 'small', backgroundColor: '#ffff99' }} className="col col-lg-1">{percent}%</td>
        if (percent > 49.99 && percent < 80) return <td style={{ fontSize: 'small', backgroundColor: '#ff8080' }} className="col col-lg-1">{percent}%</td>
        if (percent > 79.99) return <td style={{ fontSize: 'small', backgroundColor: '#cc33ff' }} className="col col-lg-1">{percent}%</td>
        
        return <td style={{ fontSize: 'small', color: 'black' }} className="col col-lg-1">&nbsp;</td>
    }

    function showTrange() {
            return (
                <>
                { isLargeScreen() ? 
                    <div style={{paddingLeft: '0px' }} className="col-sm-10">
                        <span className="sp-ot">Trange</span>
                        <table className="border border-light border-1 table-sm">
                            <tbody>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(0)}</td>
                                    {showTrangePercent(0)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(1)}</td>
                                    {showTrangePercent(1)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(2)}</td>
                                    {showTrangePercent(2)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(3)}</td>
                                    {showTrangePercent(3)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(4)}</td>
                                    {showTrangePercent(4)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(5)}</td>
                                    {showTrangePercent(5)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(6)}</td>
                                    {showTrangePercent(6)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(7)}</td>
                                    {showTrangePercent(7)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(8)}</td>
                                    {showTrangePercent(8)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">                                
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(9)}</td>
                                    {showTrangePercent(9)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(10)}</td>
                                    {showTrangePercent(10)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(11)}</td>
                                    {showTrangePercent(11)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(12)}</td>
                                    {showTrangePercent(12)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(13)}</td>
                                    {showTrangePercent(13)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(14)}</td>
                                    {showTrangePercent(14)}
                                </tr>

                                <tr style={{ backgroundColor: '#fcf5de'}} className="text-secondary">       
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(15)}</td>
                                    {showTrangePercent(15)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}></td>
                                    <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary"></td>
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeName(16)}</td>
                                    {showTrangePercent(16)}
                                </tr>
                            </tbody>
                        </table>
                        <Shark />
                    </div>
                :
                    <div style={{paddingTop: '20px' }} className="col-sm-7">
                        <span className="sp-ot">Trange</span>
                        <table className="border border-light border-1 table-sm">
                            <tbody>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(0)}</td>
                                    {showTrangePercent(0)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(1)}</td>
                                    {showTrangePercent(1)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(3)}</td>
                                    {showTrangePercent(3)}
                                </tr>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(4)}</td>
                                    {showTrangePercent(4)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(5)}</td>
                                    {showTrangePercent(5)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(6)}</td>
                                    {showTrangePercent(6)}
                                </tr>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(7)}</td>
                                    {showTrangePercent(7)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(8)}</td>
                                    {showTrangePercent(8)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(9)}</td>
                                    {showTrangePercent(9)}
                                </tr>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(10)}</td>
                                    {showTrangePercent(10)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(11)}</td>
                                    {showTrangePercent(11)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(12)}</td>
                                    {showTrangePercent(12)}
                                </tr>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(13)}</td>
                                    {showTrangePercent(13)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(14)}</td>
                                    {showTrangePercent(14)}
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(15)}</td>
                                    {showTrangePercent(15)}
                                </tr>
                                <tr style={{ backgroundColor: '#f7f7f7'}} className="text-secondary">
                                    <td style={{ fontSize: 'small', color: 'purple' }}>{getTrangeNameShort(16)}</td>
                                    {showTrangePercent(16)}
                                    <td style={{ fontSize: 'small', color: 'purple' }} />
                                    <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary" />
                                    <td style={{ fontSize: 'small', color: 'purple' }} />
                                    <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary" />
                                </tr>                            
                            </tbody>
                        </table>
                        <Shark />
                    </div>
                }
            </>
        )
    }

    function showSpinner() {
        return (
            <>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </>
        )
    }

    return (
        <>
            { tickers.length > 0 ? showTrange() :  showSpinner() }
        </>
    )
}

export default Trange